import { render, staticRenderFns } from "./ActivityBoard.vue?vue&type=template&id=89014b76&scoped=true"
import script from "./ActivityBoard.vue?vue&type=script&lang=js"
export * from "./ActivityBoard.vue?vue&type=script&lang=js"
import style0 from "./ActivityBoard.vue?vue&type=style&index=0&id=89014b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89014b76",
  null
  
)

export default component.exports